import { useQuery } from "@tanstack/react-query";
import { GET_SCORE } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { ApiResponseItems } from "api/types";
import { useSnackbar } from "hooks/useSnackbar";
import { IReturnType } from "hooks/types";
import { IScore } from "models/Score";

export const useGetScore = () => {
  const { showSnackbar } = useSnackbar();

  const {
    data: response,
    isLoading,
    isError,
    isFetching,
    isSuccess,
    refetch,
  }: IReturnType<ApiResponseItems<IScore>> = useQuery(
    [GET_SCORE],
    () => fetchApi(`weighted-average-score/kpis`).get(""),
    {
      onSuccess: (data) => {
        showSnackbar("Score Fetched Successfully", "success");
      },
      onError: (error) => {
        showSnackbar("Failed to retrieve Score", "error");
      },
    }
  );
  const score = response?.data?.item?.weighted_average_score;

  return { score, isLoading, isError, isFetching, isSuccess, refetch };
};
